export default __webpack_public_path__ + "static/media/pr_c_09.dbcda8d2.jpg";